"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageMonthlyState = void 0;
var MortgageCommonState_init_1 = require("@/pages/mortagage/states/MortgageCommonState.init");
exports.defaultMortgageMonthlyState = __assign(__assign({}, MortgageCommonState_init_1.defaultMortgageCommonState), { propertyValue: 8000000, propertyValueMin: 0, propertyValueMax: 100000000, propertyValueStep: 100000, loanAmount: 7200000, loanAmountPercent: 90, loanAmountPercentMin: 0, loanAmountPercentMax: 100, loanAmountStep: 1, tenor: 30, tenorMin: 1, tenorMax: 30, tenorStep: 1, interestRate: 3.5, interestRateMin: 0.1, interestRateMax: 10, interestRateStep: 0.01, nonCorporate: true, nonFirstTime: false, hasTransactedRecently: false, hasTransactedRecentlyMonth: 6, hasTransactedRecentlyMonths: [6, 12, 36], result: null, hasExtraStampDuty: false });
